import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
const AccomImg = require('../../../../www/images/accommodation.svg');
import { Checkbox, ListItem } from 'material-ui';
import { updateSuppProfileProps } from '../../../stores/profile/company/profile-actions';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const ImportData = props => {
  const {
    updateProp,
    profileReducer,
    productType,
  } = props;

  const { idToImportTo: locToFilter } = profileReducer;
  const locItems = [{ text: 'Cover Image', db: 'coverImageUrl' },
    { text: 'Company Types', db: 'company_types' },
    { text: 'Address', db: 'address' },
    { text: 'Website', db: 'website' },
    { text: 'Phone', db: 'phone' },
    { text: 'Description', db: 'description' },
    { text: 'Market Segments', db: 'segments' },
    { text: 'Marketing Materials', db: 'media' },
    { text: 'Contacts', db: 'contact_informations' }];

  const locAccom = [{ text: 'Rating and Amenities', db: 'rating_and_amenity' },
    { text: 'Number of Rooms', db: 'total_number_of_rooms' }];

  const filterOutLoc = R.propOr([], 'locations', profileReducer).filter(loc => R.propOr('', 'id', loc) !== (locToFilter || ''));

  return (
    <div style={{ borderRadius: '3px', border: '1px solid grey' }}>
      {
        isNilOrEmpty(filterOutLoc) ? <span style={{ padding: '5px', color: 'red' }}>You do not have any {productType === 'Accommodation' ? 'properties' : 'locations'} to import from.</span> :
          filterOutLoc.map((loc, i) => {
            const checkProdType = productType === 'Accommodation' ? locItems.concat(locAccom) : locItems;
            const itemsToImport = R.pathOr([], ['itemToImport', 'itemsToImport'], profileReducer);
            const checkName = R.equals(loc.id, R.pathOr([], ['itemToImport', 'locId'], profileReducer));
            return (
              <ListItem
                key={i}
                leftCheckbox={
                  <Checkbox
                    onCheck={R.ifElse(
                      () => checkName,
                        () => updateProp({ itemToImport: {} }),
                      () => updateProp({ itemToImport: { locId: loc.id, itemsToImport: checkProdType } })
                    )}
                    checked={checkName}
                  />
                }
                primaryText={
                  <span>
                    <img src={AccomImg} height="16" style={{ margin: '0 10px 0 -10px' }}/>
                    {loc.name} {R.pathOr('', ['itemToImport', 'locId'], profileReducer) === loc.id ? ` - Importing ${R.pathOr('', ['itemToImport', 'itemsToImport', 'length'], profileReducer)} Items` : ''}
                  </span>
                }
                initiallyOpen={false}
                nestedItems={checkProdType.map((item, j) => {
                  const isChecked = R.contains(item.text, itemsToImport.map(obj => obj.text)) && R.pathOr('', ['itemToImport', 'locId'], profileReducer) === loc.id;
                  return (
                    <ListItem
                      key={j}
                      primaryText={item.text}
                      leftCheckbox={
                        <Checkbox
                          onCheck={R.ifElse(
                            () => isChecked,
                              () => updateProp({ itemToImport: R.merge(R.propOr({}, 'itemToImport', profileReducer), { itemsToImport: R.without([item], itemsToImport) }) }),
                            () => updateProp({ itemToImport: R.merge(R.propOr({}, 'itemToImport', profileReducer), { itemsToImport: R.append(item, itemsToImport), locId: loc.id }) })
                          )}
                          checked={isChecked}
                        />
                      }
                    />
                  );
                })}
              />
            );
          })
      }
    </div>
  );
};

ImportData.propTypes = {
  updateProp: PropTypes.func,
  profileReducer: PropTypes.object,
  productType: PropTypes.string,
  locations: PropTypes.array,
};

const mapStateToProps = ({ profile, user }) => ({
  profileReducer: profile.toJS(),
  productType: user.getIn(['company', 'productType']),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportData);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/importLocData.jsx